import { IRawHotel } from "../types/IRawHotel";
import { RenovationType } from "../types/IHotel";
const getRenovationType = (hotel: IRawHotel) => {
    if(!hotel.builtDate && !hotel.renovationDate) return null;
    const currentYear = new Date().getFullYear();
    if(hotel.builtDate && !hotel.renovationDate && currentYear - hotel.builtDate <= 5) {
        return RenovationType.RecentlyOpened;
    }

    if(hotel.renovationDate && currentYear - hotel.renovationDate <= 5) {
        return RenovationType.FreshRenovation;
    }

    return null;
}

export default getRenovationType;